import { CopyButton } from '../feedback/CopyButton'

export interface JsonViewProps {
  value: unknown
  title?: string
  maxHeight?: number
  copy?: boolean
}

/** Pretty JSON in the kit's code block, with a copy button. */
export function JsonView({ value, title, maxHeight = 320, copy = true }: JsonViewProps) {
  const text = typeof value === 'string' ? value : JSON.stringify(value, null, 2)
  return (
    <div>
      {(title || copy) && (
        <div className="mb-1 flex items-center justify-between gap-2">
          <span className="text-2xs font-semibold uppercase tracking-wide text-muted">{title}</span>
          {copy && <CopyButton text={text} />}
        </div>
      )}
      <pre className="code-block" style={{ maxHeight }}>
        {text}
      </pre>
    </div>
  )
}
